const REJECTION_MARKERS = [
    'user rejected',
    'user denied',
    'user canceled',
    'user cancelled',
    'action_rejected',
    'userrejectedrequesterror',
];

/**
 * Wallets report a cancelled prompt through many shapes (viem error classes,
 * EIP-1193 provider objects, already-flattened messages), so match on the text
 * of the whole error rather than on a single class.
 */
function rejectionText(error: unknown): string {
    if (typeof error === 'string') return error;
    if (!(error instanceof Error)) return '';
    const cause = 'cause' in error ? rejectionText(error.cause) : '';
    return `${error.name} ${error.message} ${cause}`;
}

export function isUserRejection(error: unknown): boolean {
    const text = rejectionText(error).toLowerCase();
    return REJECTION_MARKERS.some((marker) => text.includes(marker));
}
